import { render, staticRenderFns } from "./AddGoodsModal.vue?vue&type=template&id=ee4f5f4c&scoped=true"
import script from "./AddGoodsModal.vue?vue&type=script&lang=js"
export * from "./AddGoodsModal.vue?vue&type=script&lang=js"
import style0 from "./AddGoodsModal.vue?vue&type=style&index=0&id=ee4f5f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4f5f4c",
  null
  
)

export default component.exports